import * as React from 'react';
import { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { Button, Col, Row } from "reactstrap";
import { createBrowserHistory } from 'history';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DABDropDown, LoadingSpinnerModal } from '../../components/dab';
import { readingPlanAction } from '../../actions/readingPlanAction';
import { channelAction } from '../../actions/channelAction';
import { showAlert } from "../common/functions";


interface IReadingPlanProps {
	dispatch: Dispatch<any>;
	readingPlanData: any;
	channelData: any;
}

const ReadingPlanCreateNew: React.SFC<IReadingPlanProps> = ({
	dispatch, readingPlanData, channelData }) => {
	const initialValue = [{ text: "", value: 0, checked: false }];
	const initialInputValue = {
		channelId: -1,
		year: -1
	};

	const history = useHistory();

	const [isChannelLoaded, setIsChannelLoaded] = useState(false);
	const [isFormSubmitted, setIsFormSubmitted] = useState(false);
	const [channelList, setChannelList] = useState(initialValue);
	const [frmInput, setFrmInput] = useState(initialInputValue);
	const [yearList, setYearList] = useState(initialValue);
	const [showModal, setShowModal] = useState(false);
	const [isDirty, setIsDirty] = useState<boolean>(false)

	React.useEffect(() => {
		if (!isChannelLoaded) {
			dispatch(channelAction.channelGetByfilter());
		}
	}, []);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};


	if (!isChannelLoaded && !channelData.isLoading) {
		if (channelData.isListSuccess) {
			channelData.isListSuccess = false;
			setIsChannelLoaded(true);

			if (channelList && channelList.length <= 1) {
				var list: any[] = [];
				var item = { text: "", value: -1, checked: true };
				list.push(item);
				channelData.items.sort((a: any, b: any) => a.title?.localeCompare(b.title)).forEach((data) => {
					var item1 = { text: data.title, value: data.channelId, checked: true };
					list.push(item1);
				});
				setChannelList(list);
			}

			if (yearList && yearList.length <= 1) {
				var list1: any[] = [];
				var year = new Date().getFullYear();
				list1.push({ text: "", value: -1, checked: true });
				for (var i = 0; i < 2; i++) {
					var data = year + i;
					list1.push({ text: data, value: data, checked: true });
				}
				setYearList(list1);
			}
		}
	}


	if (isFormSubmitted && readingPlanData.isSuccess && !readingPlanData.isError) {
		showAlert(readingPlanData.error, false);
		readingPlanData.isSuccess = false;
		showAlert(readingPlanData.status, false);
		setTimeout(() => window.location.href = "/readingplan?id=" + readingPlanData.readingPlanId, 2500)
		setShowModal(false)
	}

	if (isFormSubmitted && !readingPlanData.isSuccess && readingPlanData.isError) {
		readingPlanData.isError = false;
		if (readingPlanData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(readingPlanData.status, true);
		}
		if (showModal) {
			setShowModal(false);
		}
	}

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;

		setFrmInput({
			...frmInput,
			[name]: value,
		});
		setIsDirty(true)
	};

	const handleBackClick = (event) => {
		event.preventDefault();
		history.goBack();
	}

	const handleNextClick = (event) => {
		event.preventDefault();
		if (frmInput.channelId > 0 && frmInput.year > 0) {
			setShowModal(true);
			setIsFormSubmitted(true);
			dispatch(readingPlanAction.readingPlanSave({ readingPlan: frmInput }));
		}
		else {
			showAlert("Did not select channel or year",true)
		}
	}

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!isFormSubmitted && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !isFormSubmitted])

	return (
		<div>
			<br />
			<h5>
				Create a blank reading plan for a new year. If you'd like to start your reading plan with a copy from an existing plan, return to the reading plan list and copy a plan from there. </h5>
			<br />
			<br />
			<form name="createform" onSubmit={handleNextClick} className="create-form">
				<div className={["row mb-3"].join(" ")}>
					<label htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")}>Channel</label>
					<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="channelContainer">
						<DABDropDown
							type="select"
							className="form-select"
							id="channelId"
							isRequired={true}
							options={channelList}
							value={frmInput.channelId}
							onChange={(event) => { handleInputChange(event) }}
							isHover={false}
						/>
					</div>
				</div>

				<div className={["row mb-3"].join(" ")}>
					<label htmlFor="year" className={["col-sm-2 col-form-label"].join(" ")}>Year</label>
					<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="yearContainer">
						<DABDropDown
							type="select"
							className="form-select"
							id="year"
							isRequired={true}
							options={yearList}
							value={frmInput.year}
							onChange={(event) => { handleInputChange(event) }}
							isHover={false}
						/>
					</div>
				</div>
				<br /><br />
				<div className='card-box'>
					<Row className="create-button">
						<Col lg="6">
							<Button className="" onClick={(e) => { handleBackClick(e); }}>CANCEL</Button>
						</Col>
						<Col lg="3" data-testid="createButtonContainer">
							<Button type="submit" className="btn-submit-frm" value="Next">CREATE</Button>
						</Col>
					</Row>
				</div>
			</form>
			{
				showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
				)
			}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { readingPlanData, channelData } = state;
	return {
		readingPlanData, channelData
	};
};

export default connect(mapStateToProps)(ReadingPlanCreateNew);
